import * as React from 'react'
import { StructuredText, renderNodeRule } from 'react-datocms'

import { Text } from '@factorialco/deprecated-design-system'
import {
  isBlockquote,
  isHeading,
  isList,
  isListItem,
  isParagraph,
} from 'datocms-structured-text-utils'

import './index.styles.css'
type StructuredTextType = {
  id: string | number
  stepByStepDescription: string
}

const StepByStepDescription = ({ stepByStepDescription, id }: StructuredTextType) => {
  const parsedStepByStepDescription = JSON.parse(stepByStepDescription)

  return (
    <div className={'StepByStepDescription_formattedText'}>
      <StructuredText
        data={parsedStepByStepDescription}
        key={id}
        customNodeRules={[
          renderNodeRule(isHeading, ({ key, children }) => {
            return (
              <div className={'StepByStepDescription_heading'} role="heading" key={key}>
                <Text size="400" weight="medium" color="grey1000">
                  {children}
                </Text>
              </div>
            )
          }),
          renderNodeRule(isBlockquote, ({ key, children }) => {
            return (
              <p className={'StepByStepDescription_blockquote'} key={key}>
                {children}
              </p>
            )
          }),
          renderNodeRule(isList, ({ key, children }) => {
            return (
              <ol className={'StepByStepDescription_list'} key={key}>
                {children}
              </ol>
            )
          }),
          renderNodeRule(isListItem, ({ key, children }) => {
            return (
              <li className={'StepByStepDescription_listItem'} key={key}>
                {children}
              </li>
            )
          }),
          renderNodeRule(isParagraph, ({ key, children }) => {
            return (
              <p className={'StepByStepDescription_paragraph'} key={key}>
                {children}
              </p>
            )
          }),
        ]}
      />
    </div>
  )
}

export default StepByStepDescription
